export enum FilterContentType {
  list = 'List',
  positionedList = 'PositionedList',
  listWithSortPriority = 'ListWithSortPriority',
  text = 'Text'
}
